import React from "react";
import classNames from "classnames";

import { default as MultiSelect } from "components/Input/MultiSelect";
import Select from "components/Input/Select";
import Checkbox from "components/Input/Checkbox";

import classes from "./styles.module.scss";

const Filters = ({
    allModels = [],
    allUpgradePackages = [],
    selectedModels = [],
    setSelectedModels = () => {},
    selectedMetric = "",
    setSelectedMetric = () => {},
    waterfallAxisUnit = "percent",
    setWaterfallAxisUnit = () => {},
    waterfallAbsoluteAvailable = false,
    selectedUpgradePackage = [],
    setSelectedUpgradePackage = () => {},
    hideNAValues = false,
    setHideNAValues = () => {},
}) => {
    const isEnergy = selectedMetric === "energySavings";
    const absoluteLabel = isEnergy ? "GJ" : "tCO₂";
    const unitOptions = [
        { label: "%", value: "percent" },
        {
            label: absoluteLabel,
            value: "absolute",
            disabled: !waterfallAbsoluteAvailable,
            disabledTooltip: !waterfallAbsoluteAvailable
                ? "Absolute units need a positive community baseline total for this metric."
                : undefined,
        },
    ];
    return (
        <div className={classes.filtersContainer}>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel}>Model:</div>
                <MultiSelect
                    idPrefix="results-bottom-models"
                    className={classes.filterSelect}
                    options={allModels}
                    input={{
                        value: selectedModels,
                        onChange: setSelectedModels,
                    }}
                    dropdownStyles={{ top: "2rem", width: "167px", zIndex: 100 }}
                    hasSelectAll={true}
                    forcedLabel={
                        selectedModels.length === allModels.length ? "All Models" : `${selectedModels.length} Selected`
                    }
                />
            </div>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel}>Metric:</div>
                <Select
                    className={classes.filterSelect}
                    options={[
                        {
                            label: "Energy Savings",
                            value: "energySavings",
                        },
                        {
                            label: "GHG Emissions",
                            value: "emissionsSavings",
                        },
                    ]}
                    input={{
                        value: selectedMetric,
                        onChange: setSelectedMetric,
                    }}
                />
            </div>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel}>Units:</div>
                <Select
                    className={classNames(classes.filterSelect, classes.filterSelectUnit)}
                    customLabelClass={classes.filterSelectUnitLabel}
                    options={unitOptions}
                    input={{
                        value: waterfallAbsoluteAvailable ? waterfallAxisUnit : "percent",
                        onChange: setWaterfallAxisUnit,
                    }}
                />
            </div>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel} style={{ width: "161px" }}>
                    Upgrade Package:
                </div>
                <Select
                    className={classes.filterSelect}
                    options={allUpgradePackages}
                    input={{
                        value: selectedUpgradePackage,
                        onChange: setSelectedUpgradePackage,
                    }}
                />
            </div>
            <div className={classes.filterWrapper}>
                <Checkbox
                    label="Hide N/A Measures"
                    input={{
                        value: hideNAValues,
                        onChange: setHideNAValues,
                    }}
                    large
                />
            </div>
        </div>
    );
};

export default Filters;
